import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button } from '@mui/material';

interface Props {
  detail: unknown;
  testId?: string;
  toggleLabel?: string;
}

export default function ExpandableJsonDetails({
  detail,
  testId = 'expandable-json-details',
  toggleLabel = 'View technical details',
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  if (detail === undefined) {
    return null;
  }

  return (
    <Box sx={{ mt: 1 }}>
      <Button
        size="small"
        variant="text"
        startIcon={<ExpandMoreIcon sx={{ transform: isOpen ? 'rotate(180deg)' : undefined }} />}
        onClick={() => setIsOpen((current) => !current)}
      >
        {isOpen ? 'Hide technical details' : toggleLabel}
      </Button>
      {isOpen && (
        <Box
          data-testid={testId}
          component="pre"
          sx={{
            bgcolor: 'grey.100',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            fontSize: 12,
            mt: 1,
            overflow: 'auto',
            p: 1.5,
            whiteSpace: 'pre-wrap',
          }}
        >
          {JSON.stringify(detail, null, 2)}
        </Box>
      )}
    </Box>
  );
}
